/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Zoom to {seconds} seconds" |
*
* @param {Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_zoom_seconds_aria_label = /** @type {((inputs: Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Zoom_Seconds_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Zoomer a ${i?.seconds} secondes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zoom auf ${i?.seconds} Sekunden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Zoom a ${i?.seconds} secondi`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Увеличить до ${i?.seconds} секунд`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Zoom a ${i?.seconds} segundos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`放大至 ${i?.seconds} 秒`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.seconds} 秒にズーム`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.seconds} सेकंड पर ज़ूम करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ampliar para ${i?.seconds} segundos`)
	return /** @type {LocalizedString} */ (`Zoom to ${i?.seconds} seconds`)
});